import { LegalPage, PRIVACY_POLICY, TERMS } from '@kkf/design'
import { useT } from '../i18n'

/**
 * `/privacy` and `/terms`.
 *
 * Two routes, one component, and the words are not this app's — they are
 * `@kkf/design`'s `config/legal.ts`, shared by all five. There is one Foundation and a
 * privacy policy is a statement about what an organisation does with what it is told, so
 * five copies would become five policies the first time one was amended.
 *
 * What this file supplies is the trail's label, which is a catalogue key and belongs to
 * this app.
 */
export function PrivacyPage() {
  const t = useT()
  return (
    <LegalPage
      document={PRIVACY_POLICY}
      updatedLabel={t('legal.updated')}
    />
  )
}

export function TermsPage() {
  const t = useT()
  return (
    <LegalPage
      document={TERMS}
      updatedLabel={t('legal.updated')}
    />
  )
}
